export const INPUT_MAX_CHARACTERS = 56;

export const AREA_MAX_CHARACTERS = 200;

export const BILLING_CONTACT_MAX_CHARACTERS = 30;
